import { normalizeWebformStep } from "intake_shared/src/util";

export function formatWebformStep(value: unknown): string {
    const webformStep = normalizeWebformStep(value);
    return webformStep ? `Step ${webformStep}` : "--";
}
